import { ref, Ref } from "vue";
import { defineStore } from "pinia";

interface State {
  isLoading: Ref<boolean>;
  error: Ref<Error | undefined>;
  setLoading: (value: boolean) => void;
  setError: (value: Error | undefined) => void;
}

export default defineStore("state", (): State => {
  const isLoading = ref<boolean>(true);
  const error = ref<Error | undefined>(undefined);

  const setLoading = (value: boolean) => {
    isLoading.value = value;
  };

  const setError = (value: Error | undefined) => {
    error.value = value;
  };

  return {
    isLoading,
    error,
    setLoading,
    setError,
  };
});
